import { AdvertisementImgBoxBase } from '../../components/advertisementImgBox'
import { BoxCutBase } from '../../../components/boxCut'
import { CircleStarBase } from '../../../components/favoriteIcon/circlrStar'
import { FallbackBackgroundBase } from '../../../components/fallbackBackground'
import { FavoriteIconBase } from '../../../components/favoriteIcon'
import { GameNameNormalBase } from '../gameNameNormal'
import { GetCssVarManager } from '../../../../components/baseCssVarProvide'
import { LabelGameStatusBase } from '../../../components/labelGameStatus'
import { LogoLoneBase } from '../../components/advertisementImgBox/logoLone'
import { MaskMaintainBase } from '../../../components/maskMaintain'
import { OuterBoxBase } from '../../components/outerBox'
import { _CssVarManagerBase } from './cssVarManagerBase'

/**
 * @deprecated
 * 不要删除它,它是一个模板参考例子,值乱写的不要使用它
 * 类的形式
 *  */
export class _CssVarManagerTemplateLarger1 extends _CssVarManagerBase {
  outerBox: GetCssVarManager<OuterBoxBase> = {
    cssType: 'default'
  }
  boxCut: GetCssVarManager<BoxCutBase> = {
    cssType: 'default',
    '--box-cut-border-color': '0.5rem'
  }
  advertisementImgBox: GetCssVarManager<AdvertisementImgBoxBase> = {
    cssType: 'larger'
  }
  logoLone: GetCssVarManager<LogoLoneBase> = {}
  fallbackBackground: GetCssVarManager<FallbackBackgroundBase> = {}
  labelGameStatus: GetCssVarManager<LabelGameStatusBase> = {}
  maskMaintain: GetCssVarManager<MaskMaintainBase> = {}
  favoriteIcon: GetCssVarManager<FavoriteIconBase> = {}
  circleStar: GetCssVarManager<CircleStarBase> = {}
  gameNameNormal: GetCssVarManager<GameNameNormalBase> = {}
}

/**
 * @deprecated 不要删除它,它是一个模板参考例子,值乱写的不要使用它
 * 函数的形式
 * PS:也可以使用变量的形式,不过需要注意对象的指向,特定场景下使用的地方需要深拷贝一下
 */
export const _cssVarManagerTemplateLarger2: () => GetCssVarManager<_CssVarManagerBase> =
  () => ({
    outerBox: {
      cssType: 'default'
    },
    boxCut: {
      cssType: 'default',
      '--box-cut-border-color': '0.5rem'
    },
    advertisementImgBox: {
      '--advertisement-img-box-height': ''
    }
  })
